"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ordering: {
        isLegacyOrderingOnline: 'legacy-ordering-online',
        isFeeFreeTrackingEnabled: 'mav801FeeFreeTrackingEnabled',
        isTopupTimeoutFixEnabled: 'mav1024TopUpTimeOutFixEnabled',
        isGuestOrderingEnabled: 'orderingPortalGuestOrderingEnabled',
    },
    services: {
        isLegacyServicesOnline: 'legacy-services-online',
    },
    supplierService: {
        enableSalesReport: 'faas-sales-report-enabled',
        enableItemsSummaryReport: 'supplier-portal-items-summary-report-enabled',
        enableItemsSummaryReportV2: 'faas-item-summary-report-v2-enabled',
        enableItemsByClassReportV2: 'faas-item-by-class-report-v2-enabled',
        enableClassReportV2: 'faas-class-report-v2-enabled',
        enableItemsReportV2: 'faas-items-report-v2-enabled',
        enableItemsReportCompact: 'faas-items-report-compact-enabled',
        enableItemsReportByOrderIdsV2: 'faas-items-report-foom-v2-enabled',
        enableClassReportFoomV2: 'faas-class-report-foom-v2-enabled',
        enableItemsSummaryReportWithoutOrderIds: 'faas-item-summary-report-woi-enabled',
    },
    userPortal: {
        isTopUpUiForPreferedPaymentMethodEnabled: 'mav878PrefereredPaymentMethodTopupUiComponent',
        isOrderFoodDetanglingEnabled: 'mav582IsOrderFoodDetanglingEnabled',
        isStudentScreenRebuildEnabled: 'te24StudentScreenRebuild',
        isPublicScreensNewDesignEnabled: 'MAV-912-IsPublicScreensNewDesignEnabled',
    },
    items: {
        createItemEnabled: 'create-item-enabled',
        updateQuantitySellLimitOnItems: 'supplier-portal-update-quantity-sell-limit-on-items',
    },
    flexiBuzz: {
        supplierPortalParentNotificationsEnabled: 'supplier-portal-parent-notifications-enabled',
    },
    supplierGuestOrdering: {
        supplierPortalGuestOrderingEnabled: 'supplier-portal-guest-ordering-enabled',
        supplierPortalEventServiceDescriptionEnabled: 'supplier-portal-event-service-description-enabled',
    },
};
//# sourceMappingURL=FeatureFlagList.js.map